<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('census_database')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('census_database')"
                              :isFilter="false"/>
            </template>
            <div class="row">
                <div class="col-12 col-md-12 col-xl-12 col-xxl-12 mt-4">
                    <ValidationObserver ref="form">
                        <div class="row">
                            <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                                <ValidationProvider name="database" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('database')">
                                        <multi-selectbox :multiple="false" :validate-error="errors[0]" v-model="form.database" :options="databases">

                                        </multi-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>

                            <div class="col-12 col-md-12 col-xl-12 col-xxl-12">
                                <div class="row">
                                    <div class="col-sm-6 col-xs-12 mb-5">
                                        <b-button @click="sendSetting"
                                                  type="button"
                                                  variant="primary"
                                                  class="btn-lg d-flex justify-content-between align-items-center">
                                            {{ $t('save').toUpper() }}
                                        </b-button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </ValidationObserver>
                </div>
            </div>

        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";


// Services
import SettingsService from "@/services/SettingsService";

// Other
import {ValidationObserver, ValidationProvider} from "vee-validate";
import moment from "moment";
import SelectDate from "@/components/interactive-fields/SelectDate";
import TimePicker from "@/components/elements/TimePicker.vue";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";

export default {
    components: {
      MultiSelectbox,
        AppLayout,
        Header,
        HeaderMobile,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            form: {
                database: 'default',
            },
            databases: []
        }
    },
    metaInfo() {
        return {
            title: this.$t("census_database")
        }
    },
    methods: {
        async sendSetting() {
            if(this.checkPermission('system_setcensusdatabase')){
                const isValid = await this.$refs.form.validate();
                if (isValid) {

                    SettingsService.setCensusDatabase(this.form).then(response => {
                        this.$toast.success("Updated")
                        this.getSettings()
                    }).catch(e => {
                        this.showErrors(e)
                    })
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }

        },
        getSettings() {
            this.$store.dispatch('auth/getUser').then(()=>{
              let user = this.$store.getters['auth/getUser'];
              this.form.database = 'default'
              if(user.database){
                if(user.database.indexOf('census') > -1){
                  this.form.database = user.database
                }
              }
            })


        }
    },
    created() {
      SettingsService.getCensusDatabases()
          .then(response => {
            let data = response.data.data
            this.databases = [{value: "default", text: "Default"}];
            data.forEach(item => {
              this.databases.push({
                text: item.name,
                value: item.database
              })
            })

          })

        this.getSettings()
    }
}
</script>
